import React from "react";
import { Container , Row , Col } from "react-bootstrap";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import Traderradar from "../../../Images/trader-radar.png";
import "./CockPit.css";
import { useNavigate } from "react-router-dom";
function CockPit(){
    let navigate = useNavigate();
    const routeCockPit = () => {
        let path = "../TradeRadar";
        navigate(path);
    }
    return(
        <>
            <section className="cockpit-box">
                <Container className="yellow-line">
                    <Row className="align-items-center ">
                        <Col md={7} sm={12} xs={12}>
                            <div className="tool-detail">
                                <h2>Trade Radar</h2>
                                <p>Get your trading to the next level with the help of powerful tools, advance screeners, real time charts and many more. </p>
                                <p>Access the tools from anywhere for unique decision making edge in markets. With an easy to use Interface, do it all by yourself, without becoming a programmer or seeking their help.</p>
                                <span onClick={routeCockPit}>    
                                    <ReadMore name="Know" />
                                </span>
                            </div>
                        </Col>
                        <Col md={5} sm={12} xs={12}  className="text-center">
                            <img src={Traderradar} alt="Traderradar-tool" className="img-fluid"></img>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default CockPit;